var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.1568 2.19149C1.18772 2.87663 2.21044 3.56568 3.07372 4.45289C2.57887 6.56746 4.55389 8.25693 6.35513 9.25226C7.06028 9.64191 7.37195 9.91508 8.15693 9.78379L11.2483 12.7139C5.43062 14.6041 -1.09831 6.6741 0.1568 2.19149ZM8.95382 9.03041L9.63195 8.3641C9.82749 8.17165 10.1503 8.16922 10.3492 8.35849L12.8494 10.7399C13.0482 10.9291 13.0507 11.2415 12.8552 11.4338L12.1768 12.1002C11.9812 12.2925 11.6584 12.295 11.4594 12.1057L8.95929 9.72433C8.76037 9.53516 8.75796 9.22285 8.95382 9.03041ZM0.766146 0.789995L1.25826 0.21192C1.46921 -0.0358558 1.85153 -0.0716151 2.10765 0.132467L4.66718 2.17234C4.9233 2.37663 4.95994 2.74628 4.7492 2.99438L4.25687 3.57213C4.04581 3.82023 3.6636 3.85567 3.40737 3.65159L0.848274 1.61172C0.592156 1.40764 0.554974 1.03777 0.766146 0.789995Z",
    fill: "#B99750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconPhone);
export default __webpack_public_path__ + "static/media/phone-icon-phone.48cfab1d1ea28abcbf612043a3df737c.svg";
export { ForwardRef as ReactComponent };